<template>
    <v-dialog max-width="800px" v-model="cDialog" persistent>
        <v-card>
            <v-card-title>
                <div
                        style="text-align: center;text-transform:uppercase;width: 100%;border-bottom: 0px solid gray; height:0px">
                    <v-btn @click="onCancel" icon style="float: right">
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
            </v-card-title>

            <v-card-text>

                <v-form>
                    <v-card-title>
                        <div class="headline dialog-header">
                            <v-toolbar color="primary" dark>
                                <v-toolbar-title style="padding-left: 10px">{{$t('lang.customer.customerGeneral')}}
                                </v-toolbar-title>

                            </v-toolbar>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex xs6 style="padding: 10px">
                                <div class="form-group">
                                    <label class="label">{{$t(customerName)}}: </label>
                                    <label class="text">{{item.customer.customerName}}</label>
                                </div>
                            </v-flex>
                            <v-flex xs6 style="padding: 10px">
                                <div class="form-group">
                                    <label class="label">{{$t(customerEmail)}}: </label>
                                    <label class="text">{{item.customer.email}}</label>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-form>
            </v-card-text>
                <v-form ref="viewPresentForm">
                    <v-container>
                        <v-card-title>
                            <div class="headline dialog-header">
                                <v-toolbar color="primary" dark>
                                    <v-toolbar-title style="padding-left: 10px">{{$t(formName)}}</v-toolbar-title>
                                </v-toolbar>
                            </div>
                        </v-card-title>
                        <v-card-text>
                            <v-layout wrap>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field type="text" :label="$t('lang.customerRepresent.representFullName')"
                                                  v-model.trim="item.fullName"
                                                  name="representFullName" v-validate="'required'" maxLength="250"
                                                  :error-messages="errors.first('representFullName')"
                                                  :data-vv-as="$t('lang.customerRepresent.representFullName')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field type="text" :label="$t('lang.customerRepresent.phone')"
                                                  v-model.trim="item.phone"
                                                  name="phone" v-validate="'required|phone'" maxLength="50"
                                                  :error-messages="errors.first('phone')"
                                                  :data-vv-as="$t('lang.customerRepresent.phone')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field type="text" :label="$t('lang.customerRepresent.representEmail')"
                                                  v-model.trim="item.email"
                                                  name="representEmail" v-validate="'required|email'" maxLength="250"
                                                  :error-messages="errors.first('representEmail')"
                                                  :data-vv-as="$t('lang.customerRepresent.representEmail')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field type="text" :label="$t('lang.customerRepresent.address')"
                                                  v-model.trim="item.address"
                                                  name="phone" v-validate="" maxLength="2000"
                                                  :error-messages="errors.first('address')"
                                                  :data-vv-as="$t('lang.customerRepresent.address')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field type="text" :label="$t('lang.customerRepresent.roleName')"
                                                  v-model.trim="item.roleName"
                                                  name="roleName" v-validate="" maxLength="500"
                                                  :error-messages="errors.first('roleName')"
                                                  :data-vv-as="$t('lang.customerRepresent.roleName')"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-container>
                </v-form>
                <div style="text-align: right">
                    <v-btn color="primary" @click="onSave">
                        <v-icon dark left>save</v-icon>
                        {{$t('lang.common.save')}}
                    </v-btn>
                    <v-btn color="error" @click="onCancel">
                        <v-icon dark left>cancel</v-icon>
                        {{$t('lang.common.cancel')}}
                    </v-btn>
                </div>
        </v-card>
    </v-dialog>


</template>

<script>
    import {message} from '../../../../services';
    import axios from "axios"

    export default {
        name: 'view-present',
        components: {message, axios},
        props: {
            customerId: {
                type: Number,
                default: -1,
            },
            cDialog: {
                type: Boolean,
                default: false,
            }
        },
        data: () => {
            return {
                formName: "lang.customerRepresent.formName",
                customerName: "lang.customer.customerName",
                customerEmail: "lang.customer.email",
                representFullName: "",
                representEmail: "",

                item: {
                    customer: {
                        email: null,
                        customerName: null
                    }
                },
            }
        },
        watch: {
            customerId: function (value) {
                if (value != -1) {
                    const formData = {customerId: value};
                    //console.log("formData", formData);
                    axios.post(process.env.VUE_APP_API_URL + "/customerDeputy/searchOne", formData).then(
                        data => {
                            this.item = data;
                            //console.log("data", data);

                            //this.$refs.viewPresentForm.reset();
                        }
                    )
                } else{
                    this.item = {customer:{
                            email: null,
                            customerName: null}}
                }
            }
        },
        methods: {
            copyValue: function (value) {
                let ob = {};
                for (let key in value) {
                    ob[key] = value[key];
                }
                return ob;
            },
            onCancel: function () {
                this.$emit("closePresent", '');
            },
            onSave: function () {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    axios.post(process.env.VUE_APP_API_URL + "/customerDeputy/save", this.item).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.save_success"));
                                this.onCancel();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    );
                });
            }
            ,
        },
        created() {

            if (this.$route.params.id) {
                this.customerId = this.$route.params.id;
            }
        }
    }
</script>
